"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var get_1 = __importDefault(require("lodash/get"));
var react_1 = require("react");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var FieldNumber_1 = require("shared/components/Form/Fields/FieldNumber");
var Dropdown_1 = __importDefault(require("shared/components/Form/Select/Dropdown"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var general_1 = require("utils/general");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var utils_1 = require("./utils");
var WizardParts_1 = require("./WizardParts");
var FIELDS = ['estimationAnnualSpend', 'estimationNumTools'];
var FIELDS_FOR_NEXT = [
    'estimationNumTools', 'estimationAnnualSpend.amount', 'estimationAnnualSpend.currency',
];
var SaasQuiz = function () {
    var _a;
    var formValues = (0, react_final_form_1.useFormState)({ subscription: { values: true } }).values;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _b = __read((0, hooks_1.useSubmitter)('users', profile === null || profile === void 0 ? void 0 : profile.id), 1), profileSubmitter = _b[0];
    var CURRENCY_OPTIONS = (0, general_1.makeValueLabelArray)(interfaces_1.CURRENCY_CODES);
    // TODO: Cleanup the value in estimationAnnualSpend before we use it anywhere else, as it might have some stale data
    var submit = (0, utils_1.submitOnChange)(formValues.profile, profile, profileSubmitter, FIELDS);
    var _c = __read((0, react_1.useState)(false), 2), isSelected = _c[0], setIsSelected = _c[1];
    var toolAdornment = ((_a = profile.estimationAnnualSpend) === null || _a === void 0 ? void 0 : _a.amount) || isSelected ? {
        endAdornment: ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, __assign({ position: "end", disableTypography: true }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: "/ year" })) }))),
    } : {};
    return ((0, jsx_runtime_1.jsx)(WizardParts_1.StepTemplate, __assign({ onBeforeNext: submit, isNextDisabled: !FIELDS_FOR_NEXT.map(function (f) { return (0, get_1.default)(formValues.profile, f); }).every(Boolean) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%", width: "100%" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mb: 2 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Before we let you go" })) })), (0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Let's do a quick experiment" })) }), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, sx: { mt: 1, mb: 4 } }, { children: "Find out how accurate you are about your software spend" })), (0, jsx_runtime_1.jsxs)(material_1.Box, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "If you had to guess," })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", mt: 1 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: "20%" }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: Dropdown_1.default, name: "profile.estimationAnnualSpend.currency", options: CURRENCY_OPTIONS, defaultValue: formValues.company.baseCurrency || 'AUD' }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ ml: 2, width: "80%" }, { children: (0, jsx_runtime_1.jsx)(FieldNumber_1.FieldNumber, { name: "profile.estimationAnnualSpend.amount", label: "How much do you spend on software each year?", InputProps: toolAdornment, onFocus: function () { return setIsSelected(true); }, fullWidth: true, onBlur: function (e) { return e.target.value
                                            ? setIsSelected(true)
                                            : setIsSelected(false); } }) }))] }))] }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ my: 2 }, { children: (0, jsx_runtime_1.jsx)(FieldNumber_1.FieldNumber, { name: "profile.estimationNumTools", label: "How many tools are in your software stack?", fullWidth: true }) }))] })) })));
};
exports.default = SaasQuiz;
